import { ExpenseType, PeakSource } from "@/enums/enums";
import { Base64ToBlob } from "@/helper/transactionHelper";
import { CatchAPIService, MerchantId, SetHeaderService } from "@/helper/userHelper";
import { i18n } from "@/i18n";
import service from "../baseHttpService";
import {
  GetCreateInvoiceInput,
  GetCreatePurchaseInventoryInput,
  GetCreateQuotationInput,
  GetCreateReceiptInput,
} from "./transactionFacade";

class TransactionService {
  DoGetAISuggestionAccountByContact(contactId: any, contactTaxId: any, financeType: any, expenseType: any) {
    const _input = {
      merchantId: MerchantId(),
      contactId: contactId,
      contactTaxId: contactTaxId,
      financeType: financeType,
      expenseType: expenseType,
    };
    return service.peakRealTimeAPI
      .post("/api/Invoice/GetAISuggestionAccountByContact", _input, SetHeaderService())
      .then((res) => {
        return res;
      })
      .catch((err) => CatchAPIService(err.response));
  }
  DoGetInvoiceDetail(id: number) {
    const _input: any = {
      merchantId: MerchantId(),
      invoiceId: id,
    };
    return service.peakRealTimeAPI
      .post("/api/Invoice/GetInvoiceById", _input, SetHeaderService())
      .then((res) => {
        return res;
      })
      .catch((err) => CatchAPIService(err.response));
  }
  DoCreateInvoice(status: any, transaction: any) {
    const transactionInput = GetCreateInvoiceInput(status, transaction);
    const _input: any = {
      merchantId: MerchantId(),
      financeType: transactionInput.financeType,
      transactionItemType: transactionInput.expenseType,
      transaction: transactionInput.transaction,
      language: i18n.locale,
      isValidateCreditLimit: transaction.isValidateCreditLimit,
      source: PeakSource.LineConnect,
    };
    return service.peakRealTimeAPI
      .post("/api/Invoice/CreateInvoice", _input, SetHeaderService())
      .then((res) => {
        return res;
      })
      .catch((err) => CatchAPIService(err.response));
  }
  DoCreatePurchaseInventory(status: any, transaction: any) {
    const transactionInput = GetCreatePurchaseInventoryInput(status, transaction);
    const _input: any = {
      merchantId: MerchantId(),
      financeType: transactionInput.financeType,
      transactionItemType: transactionInput.expenseType,
      transaction: transactionInput.transaction,
      language: i18n.locale,
      isValidateCreditLimit: transaction.isValidateCreditLimit,
      source: PeakSource.LineConnect,
    };
    return service.peakRealTimeAPI
      .post("/api/Invoice/CreatePurchaseInventory", _input, SetHeaderService())
      .then((res) => {
        return res;
      })
      .catch((err) => CatchAPIService(err.response));
  }
  DoCreateQuotation(status: any, transaction: any) {
    const transactionInput = GetCreateQuotationInput(status, transaction);
    const _input: any = {
      merchantId: MerchantId(),
      financeType: transactionInput.financeType,
      transaction: transactionInput.transaction,
      language: i18n.locale,
      isValidateCreditLimit: transaction.isValidateCreditLimit,
      source: PeakSource.LineConnect,
    };
    return service.peakRealTimeAPI
      .post("/api/Quotation/CreateQuotation", _input, SetHeaderService())
      .then((res) => {
        return res;
      })
      .catch((err) => CatchAPIService(err.response));
  }
  DoCreateReceipt(status: any, transaction: any) {
    const transactionInput = GetCreateReceiptInput(status, transaction);
    const _input: any = {
      merchantId: MerchantId(),
      financeType: transactionInput.financeType,
      receipt: transactionInput.transaction,
      language: i18n.locale,
      source: PeakSource.LineConnect,
    };
    return service.peakRealTimeAPI
      .post("/api/Receipt/CreateReceipt", _input, SetHeaderService())
      .then((res) => {
        return res;
      })
      .catch((err) => CatchAPIService(err.response));
  }
  //#region InsertFileTransaction
  DoInsertQuotationFile(input: any) {
    const formData = new FormData();
    formData.append("merchantId", MerchantId());
    formData.append("transactionId", input.transactionId);
    input.fileList.forEach((file: any, index: any) => {
      const blob = Base64ToBlob(file.rawString, file.fileType);
      formData.append(`fileList[${index}]`, blob, file.fileName);
    });
    return service.peakRealTimeAPI
      .post("/api/Quotation/InsertQuotationFile", formData, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoInsertInvoiceFile(input: any) {
    const formData = new FormData();
    formData.append("merchantId", MerchantId());
    formData.append("transactionId", input.transactionId);
    input.fileList.forEach((file: any, index: any) => {
      const blob = Base64ToBlob(file.rawString, file.fileType);
      formData.append(`fileList[${index}]`, blob, file.fileName);
    });
    return service.peakRealTimeAPI.post("/api/Invoice/InsertInvoiceFile", formData, SetHeaderService()).then((res) => {
      return res;
    });
  }
  DoInsertReceiptFile(input: any) {
    const formData = new FormData();
    formData.append("merchantId", MerchantId());
    formData.append("transactionId", input.transactionId);
    input.fileList.forEach((file: any, index: any) => {
      const blob = Base64ToBlob(file.rawString, file.fileType);
      formData.append(`fileList[${index}]`, blob, file.fileName);
    });
    return service.peakRealTimeAPI.post("/api/Receipt/InsertReceiptFile", formData, SetHeaderService()).then((res) => {
      return res;
    });
  }
  DoGetSuggestionTransactionNumber(transaction: any) {
    const isCreateTaxInvoice = transaction.issueTaxInvoice != null ? transaction.issueTaxInvoice.value : false;
    const _input: any = {
      merchantId: MerchantId(),
      transactionType: transaction.transactionType,
      financeType: transaction.financeType,
      expenseType:
        transaction.expenseType === ExpenseType.PurchaseInventory ? ExpenseType.Expense : transaction.expenseType,
      date: transaction.date.value,
      isCreateTaxInvoice: isCreateTaxInvoice,
    };
    return service.peakRealTimeAPI
      .post("/api/Transaction/GetSuggestionTransactionNumber", _input, SetHeaderService())
      .then((res) => {
        return res;
      })
      .catch((err) => CatchAPIService(err.response));
  }
  DoGetBookmarkList(input: any) {
    const _input = {
      merchantId: MerchantId(),
      transactionType: input.transactionType,
      financeType: input.financeType,
      expenseType: input.expenseType,
    };
    return service.peakRealTimeAPI
      .post("/api/Bookmark/GetBookmarkList", _input, SetHeaderService())
      .then((res) => {
        return res;
      })
      .catch((err) => CatchAPIService(err.response));
  }
  DoGetBookmarkDetailList(transactionTemplateId: number) {
    const _input = {
      merchantId: MerchantId(),
      transactionTemplateId: transactionTemplateId,
    };
    return service.peakRealTimeAPI
      .post("/api/Bookmark/GetBookmarkDetail", _input, SetHeaderService())
      .then((res) => {
        return res;
      })
      .catch((err) => CatchAPIService(err.response));
  }
  DoCreateBookmark(input: any) {
    const _input = {
      merchantId: MerchantId(),
      transaction: input,
    };
    return service.peakRealTimeAPI
      .post("/api/Bookmark/SaveBookmark", _input, SetHeaderService())
      .then((res) => {
        return res;
      })
      .catch((err) => CatchAPIService(err.response));
  }
  DoDeleteBookmark(bookmarkId: number) {
    const _input = {
      merchantId: MerchantId(),
      bookmarkId: bookmarkId,
    };
    return service.peakRealTimeAPI
      .post("/api/Bookmark/DeletedBookmark", _input, SetHeaderService())
      .then((res) => {
        return res;
      })
      .catch((err) => CatchAPIService(err.response));
  }
  DoGetBookmarkForTransactionTemplate(bookmarkId: number) {
    const _input: any = {
      merchantId: MerchantId(),
      bookmarkId: bookmarkId,
    };
    return service.peakRealTimeAPI
      .post("/api/Bookmark/GetBookmarkDetailById", _input, SetHeaderService())
      .then((res) => {
        return res;
      })
      .catch((err) => CatchAPIService(err.response));
  }
  DoGetTagList() {
    const _input: any = {
      merchantId: MerchantId(),
    };
    return service.peakRealTimeAPI
      .post("/api/Transaction/GetTagList", _input, SetHeaderService())
      .then((res) => {
        return res;
      })
      .catch((err) => CatchAPIService(err.response));
  }
  DoCreateNewTag(input: any) {
    const _input = {
      merchantId: MerchantId(),
      tagName: input.tagName,
    };
    return service.peakRealTimeAPI
      .post("/api/Transaction/CreateNewTag", _input, SetHeaderService())
      .then((res) => {
        return res;
      })
      .catch((err) => CatchAPIService(err.response));
  }
}

export default new TransactionService();
